export type EventEmailTemplateBodyParts = {
    header: string;
    footer: string;
};

export type EventNotificationMessageParts = {
    header: string;
    body: string;
    footer: string;
};

const stringValue = (value: unknown): string => typeof value === "string" ? value : "";

export const parseEventEmailTemplateBody = (body?: string | null): EventEmailTemplateBodyParts => {
    const rawBody = body ?? "";
    const trimmedBody = rawBody.trim();
    if (!trimmedBody) {
        return {header: "", footer: ""};
    }

    if (trimmedBody.startsWith("{")) {
        try {
            const parsed = JSON.parse(trimmedBody) as Partial<EventEmailTemplateBodyParts & {body: string}>;

            return {
                header: stringValue(parsed.header),
                footer: stringValue(parsed.footer) || stringValue(parsed.body)
            };
        } catch {
            // Legacy templates stored the whole wrapper as plain body content.
        }
    }

    return {header: "", footer: rawBody};
};

export const parseEventNotificationMessage = (message?: string | null): EventNotificationMessageParts => {
    const rawMessage = message ?? "";
    const trimmedMessage = rawMessage.trim();
    if (!trimmedMessage) {
        return {header: "", body: "", footer: ""};
    }

    if (trimmedMessage.startsWith("{")) {
        try {
            const parsed = JSON.parse(trimmedMessage) as Partial<EventNotificationMessageParts>;

            return {
                header: stringValue(parsed.header),
                body: stringValue(parsed.body),
                footer: stringValue(parsed.footer)
            };
        } catch {
            // Legacy log rows stored plain message content.
        }
    }

    return {header: "", body: rawMessage, footer: ""};
};

export const serializeEventEmailTemplateBody = (parts: EventEmailTemplateBodyParts): string => JSON.stringify({
    header: parts.header ?? "",
    footer: parts.footer ?? ""
});

export const serializeEventNotificationMessage = (parts: EventNotificationMessageParts): string => JSON.stringify({
    header: parts.header ?? "",
    body: parts.body ?? "",
    footer: parts.footer ?? ""
});
